import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'orderBy',
    pure: false,
    standalone: false
})
export class OrderByPipe implements PipeTransform {

  value:unknown[] =[];

  static _orderByComparator(a:unknown, b:unknown):number{

    if(a === null || typeof a === 'undefined') a = 0;
    if(b === null || typeof b === 'undefined') b = 0;

    if((isNaN(parseFloat(a as string)) || !isFinite(a as number)) || (isNaN(parseFloat(b as string)) || !isFinite(b as number))){
      //Isn't a number so lowercase the string to properly compare
      if(String(a).toLowerCase() < String(b).toLowerCase()) return -1;
      if(String(a).toLowerCase() > String(b).toLowerCase()) return 1;
    }else{
      //Parse strings as numbers to compare properly
      if(parseFloat(a as string) < parseFloat(b as string)) return -1;
      if(parseFloat(a as string) > parseFloat(b as string)) return 1;
    }

    return 0; //equal each other
  }

  transform(input:unknown[], config:string = '+'): unknown[]{

    //make a copy of the input's reference
    this.value = [...input];
    let value = this.value;

    if(!Array.isArray(value)) return value;

    if(!Array.isArray(config) || (Array.isArray(config) && config.length === 1)){
      let propertyToCheck:string = !Array.isArray(config) ? config : config[0];
      let desc = propertyToCheck.substr(0, 1) === '-';

      //Basic array
      if(!propertyToCheck || propertyToCheck === '-' || propertyToCheck === '+'){
        return !desc ? value.sort() : value.sort().reverse();
      }else {
        let property:string = propertyToCheck.substr(0, 1) === '+' || propertyToCheck.substr(0, 1) === '-'
          ? propertyToCheck.substr(1)
          : propertyToCheck;

        return value.sort(function(a:unknown,b:unknown){
          return !desc
            ? OrderByPipe._orderByComparator((a as Record<string, unknown>)[property], (b as Record<string, unknown>)[property])
            : -OrderByPipe._orderByComparator((a as Record<string, unknown>)[property], (b as Record<string, unknown>)[property]);
        });
      }
    } else {
      //Loop over property of the array in order and sort
      return value.sort(function(a:unknown,b:unknown){
        for(let i:number = 0; i < config.length; i++){
          let desc = config[i].substr(0, 1) === '-';
          let property = config[i].substr(0, 1) === '+' || config[i].substr(0, 1) === '-'
            ? config[i].substr(1)
            : config[i];

          let comparison = !desc
            ? OrderByPipe._orderByComparator((a as Record<string, unknown>)[property], (b as Record<string, unknown>)[property])
            : -OrderByPipe._orderByComparator((a as Record<string, unknown>)[property], (b as Record<string, unknown>)[property]);

          //Don't return 0 yet in case of needing to sort by next property
          if(comparison !== 0) return comparison;
        }

        return 0; //equal each other
      });
    }
  }
}
